import React, {useEffect, useState} from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
} from '@mui/material';
import {DialogTitle} from '@apps-common/ui-components';
import {MAX_TITLE_LENGTH} from '@app/constants';
import {bool, func, object} from 'prop-types';
import {trackEvent} from '@app/analytics';
import {useTranslation} from 'react-i18next';
import {useUpdateFeature} from '@app/api/features';

const EditTitleModal = ({open, onClose, feature}) => {
  const {t} = useTranslation();
  const [title, setTitle] = useState('');
  const [helperText, setHelperText] = useState(false);

  const {mutate: updateFeature, isPending: isUpdating} = useUpdateFeature({
    onSuccess: () => {
      trackEvent('Feature Item', {
        action: 'Renamed',
        feature,
      });
      onClose();
    },
  });

  useEffect(() => {
    setTitle(feature?.properties?.title || '');
  }, [feature]);

  useEffect(() => {
    if (title.length >= MAX_TITLE_LENGTH) {
      setHelperText(true);
    } else {
      setHelperText(false);
    }
  }, [title.length]);

  const onSave = () => {
    updateFeature({
      feature: {
        id: feature.id,
        properties: {
          ...feature.properties,
          title,
        },
      },
    });
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle onClose={onClose} title={t('editFeatureTitleModal.title')} />
      <DialogContent>
        <TextField
          fullWidth
          value={title}
          onChange={evt => setTitle(evt.target.value)}
          inputProps={{maxLength: MAX_TITLE_LENGTH}}
          helperText={helperText ? t('editFeatureTitleModal.helperText') : ' '}
          error={!!helperText}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          {t('common:cancelBtn')}
        </Button>
        <Button
          color="primary"
          variant="contained"
          disabled={
            isUpdating ||
            title === feature?.properties?.title ||
            title.length === 0
          }
          onClick={onSave}
        >
          {isUpdating ? t('common:loadingSaveBtn') : t('common:saveBtn')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

EditTitleModal.propTypes = {
  feature: object,
  onClose: func,
  open: bool,
};

export default EditTitleModal;
